export default __webpack_public_path__ + "static/media/txt_title2.50193cf7.svg";